import {
  buttonBg,
  buttonBgActive,
  buttonBgHover,
} from '@synoptic/ui-kit/button/button.css.ts';
import { themeVars } from '@synoptic/ui-kit/theme/vars.ts';
import { boxShadows, space } from '@synoptic/ui-kit/tokens.ts';
import { style } from '@vanilla-extract/css';

export const feedFloatingAction = style({
  position: 'sticky',
  top: space.s24,
  margin: '0 auto',
  boxShadow: boxShadows.default,
  pointerEvents: 'auto',
  vars: {
    [buttonBg]: themeVars.container.secondary.background.idle,
    [buttonBgHover]: themeVars.container.secondary.background.hover,
    [buttonBgActive]: themeVars.container.secondary.background.hover,
  },
});

export const feedFloatingActionXSmall = style([
  {
    selectors: {
      '&:is(&)': {
        top: space.s2,
        padding: `${space.s2}px ${space.s8}px`,
        minHeight: 'auto',
      },
    },
  },
]);

export const feedFloatingActionContainer = style({
  paddingTop: space.s12,
  pointerEvents: 'none',
  position: 'absolute',
  inset: 0,
  zIndex: 2,
});
